import {
  ProTable as AntdProTable,
  ProTableProps as AntdProTableProps,
  RequestData,
} from '@ant-design/pro-components';
import { Empty } from 'antd';
import { useState } from 'react';

interface ProTableProps extends Omit<AntdProTableProps<any, any>, 'scroll'> {
  scroll?: boolean;
}

const ProTable = (props: ProTableProps) => {
  const [loading, setLoading] = useState(false);
  return (
    <AntdProTable
      {...props}
      onLoadingChange={loading => {
        setLoading(loading as boolean);
      }}
      rowKey={'id'}
      scroll={props.scroll === false ? undefined : { x: 'max-content' }}
      locale={{
        emptyText:
          loading || props.loading ? (
            <div
              style={{
                height: '300px',
              }}
            ></div>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Không có dữ liệu' />
          ),
        ...props.locale,
      }}
      size='large'
      columnEmptyText={false}
      request={async (params, sort, filter) => {
        params.pageIndex = params.current - 1;
        delete params.current;
        const result = (await props.request?.(
          params,
          sort,
          filter
        )) as Partial<RequestData<any>>;
        if (result.data?.length === 0 && params.pageIndex > 0) {
          params.pageIndex = params.pageIndex - 1;
          return props.request?.(params, sort, filter) as Promise<Partial<RequestData<any>>>;
        }

        return result
        // return props.request?.(params, sort, filter) as Promise<Partial<RequestData<any>>>;
      }}
      pagination={
        props.pagination === false
          ? false
          : {
            defaultCurrent: 1,
            defaultPageSize: 10,
            showTotal(total, range) {
              return `Hiển thị ${range[0]}-${range[1]} của ${total}`;
            },
            ...props.pagination,
          }
      }
      style={{ padding: 8, ...props.style }}
    />
  );
};

export default ProTable;
